/**
 * @generated SignedSource<<97b584bde32df6341e9b65dd5c19f7f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ChatMessage_Subscription$variables = {
  chatMessageId: string;
};
export type ChatMessage_Subscription$data = {
  readonly chatMessageUpdated: {
    readonly chatMessage: {
      readonly message: string;
    } | null | undefined;
  };
};
export type ChatMessage_Subscription = {
  response: ChatMessage_Subscription$data;
  variables: ChatMessage_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "chatMessageId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "chatMessageId",
    "variableName": "chatMessageId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatMessage_Subscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChatMessageUpdatedPayload",
        "kind": "LinkedField",
        "name": "chatMessageUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatMessage",
            "kind": "LinkedField",
            "name": "chatMessage",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatMessage_Subscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChatMessageUpdatedPayload",
        "kind": "LinkedField",
        "name": "chatMessageUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatMessage",
            "kind": "LinkedField",
            "name": "chatMessage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b7e173ceb4016416b9851c9c0f554888",
    "id": null,
    "metadata": {},
    "name": "ChatMessage_Subscription",
    "operationKind": "subscription",
    "text": "subscription ChatMessage_Subscription(\n  $chatMessageId: ID!\n) {\n  chatMessageUpdated(chatMessageId: $chatMessageId) {\n    chatMessage {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd391e947f797a8172ea4b609a8ea047";

export default node;
